import { ajax, getRequestUrl, formatData } from "../request";

export default {
  // 房间查询
  api_room(data, method) {
    return ajax('post', getRequestUrl('/room/detail'), data, {
      method,
    });
  },

  // 房间查询--修改
  updateRoom(data, method) {
    return ajax('post', getRequestUrl('/room/updateRoom'), data, {
      method,
    });
  },
  // 房间查询--添加房间背景
  sendRoomProp(data, method) {
    return ajax('post', getRequestUrl('/room/sendRoomProp'), data, {
      method,
    });
  },

  // 房间查询--解禁房间
  unBannedRoom(data, method) {
    return ajax('post', getRequestUrl('/room/addBlackRoom'), data, {
      method,
    });
  },

  // 房间查询--修改头像
  saveRoomAvatar(data, method) {
    return ajax('post', getRequestUrl('/api/Room/saveRoomAvatar'), data, {
      method,
    });
  },

  // 房间查询--封禁房间
  bannedRoom(data, method) {
    return ajax('post', getRequestUrl('/room/addBlackRoom'), data, {
      method,
    });
  },

  // 房间查询--房间黑名单
  roomBlackList(data, method) {
    return ajax('post', getRequestUrl('/room/blackList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--移除黑名单接口
  removeRoomBlack(data, method) {
    return ajax('post', getRequestUrl('/room/removeBlackUser'), data, {
      method,
    });
  },

  // 房间查询--房间扶持明细
  roomSupportRewardList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomSupportRewardList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间列表
  findRoomListByPage(data, method) {
    return ajax('post', getRequestUrl('/room/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
  // 房间查询--房间周榜单
  roomWeekCostRank(data, method) {
    return ajax('post', getRequestUrl('/room/roomWeekCostRank'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--置顶房间
  stickRoom(data, method) {
    return ajax('post', getRequestUrl('/api/Room/stickRoom'), data, {
      method,
    });
  },

  // 房间查询--房间标签列表
  roomTagList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomTagList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间等级列表
  roomLevelList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/findRoomLevelList'), data, {
      method,
    });
  },

  // 房间查询--修改房间靓号
  saveRoomNumber(data, method) {
    return ajax('post', getRequestUrl('/room/updateRoomNo'), data, {
      method,
    });
  },

  // 房间查询--修改房间等级
  saveRoomLevel(data, method) {
    return ajax('post', getRequestUrl('/api/Room/saveRoomLevel'), data, {
      method,
    });
  },

  // 房间查询--保存标签信息
  roomTagAdd(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomTagAdd'), data, {
      method,
    });
  },

  // 房间查询--勋章增加，删除
  roomMedal(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomMedal'), data, {
      method,
    });
  },

  // 房间查询--删除标签
  roomTagDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomTagDelete'), data, {
      method,
    });
  },

  // 房间查询--房间背景列表
  roomBackgroundList(data, method) {
    return ajax('post', getRequestUrl('/room/background/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间背景分区列表
  roomBackgroundRegionList(data, method) {
    return ajax('post', getRequestUrl('/room/background/partition/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--保存房间背景
  roomBackgroundSave(data, method) {
    return ajax('post', getRequestUrl('/room/background/save'), data, {
      method,
    });
  },

  // 房间查询--保存房间背景 分区
  roomBackgroundSetRegion(data, method) {
    return ajax('post', getRequestUrl('/room/background/setRegion'), data, {
      method,
    });
  },

  // 房间查询--修改房间背景分区
  roomBackgroundSetRegionUpdate(data, method) {
    return ajax('post', getRequestUrl('/room/background/partition/save'), data, {
      method,
    });
  },

  // 房间查询--批量删除 房间背景分区
  roomBgRegionDelete(data, method) {
    return ajax('post', getRequestUrl('/room/background/partition/batchDelete'), data, {
      method,
    });
  },

  // 房间查询--从所有分区中下架
  roomBgRegionoffAll(data, method) {
    return ajax('post', getRequestUrl('/room/background/partition/offAll'), data, {
      method,
    });
  },

  // 房间查询--房间背景详情
  roomBackgroundDetail(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomBackgroundDetail'), data, {
      method,
    });
  },

  // 房间查询--删除房间背景
  roomBackgroundDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomBackgroundDelete'), data, {
      method,
    });
  },

  // 房间查询--上架/下架房间背景
  roomBackgroundIsOn(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomBackgroundIsOn'), data, {
      method,
    });
  },

  // 房间查询--审核管理--房间背景--审核列表
  roomBgReviewList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomBgReviewList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--审核管理--房间背景--批量审核背景
  changeRoomBgBatch(data, method) {
    return ajax('post', getRequestUrl('/api/Room/changeRoomBgBatch'), data, {
      method,
    })
  },

  // 房间查询--审核管理--活动申请--活动审核列表
  roomActiveList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomActiveReviewList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--审核管理--活动申请--删除活动
  deleteRoomActive(data, method) {
    return ajax('post', getRequestUrl('/api/Room/deleteRoomActive'), data, {
      method,
    })
  },

  // 房间查询--审核管理--活动申请--批量审核活动
  changeRoomActiveBatch(data, method) {
    return ajax('post', getRequestUrl('/api/Room/changeRoomActiveBatch'), data, {
      method,
    })
  },

  // 房间查询--审核管理--活动申请--置顶活动
  topActive(data, method) {
    return ajax('post', getRequestUrl('/api/Room/topActive'), data, {
      method,
    })
  },

  // 房间查询--活动扶持系统--活动申请--置顶活动
  activityPoorList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/activityPoorList'), data, {
      method,
    })
  },

  // 房间查询--活动扶持系统--发放扶持
  sendPoorGift(data, method) {
    return ajax('post', getRequestUrl('/api/Room/sendPoorGift'), data, {
      method,
    })
  },

  // 房间查询--审核管理--房间解散申请--房间解散申请列表
  roomDisbandApplicationList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomDisbandApplicationList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--审核管理--房间解散申请--忽略房间解散申请
  roomReviewDisbandApplication(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomReviewDisbandApplication'), data, {
      method,
    })
  },

  // 房间查询--房主认证--房间认证列表
  roomCertificationList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomCertificationList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房主认证--保存房间认证信息
  roomCertificationSave(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomCertificationSave'), data, {
      method,
    })
  },

  // 房间查询--房主认证--删除房间认证
  roomCertificationDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomCertificationDelete'), data, {
      method,
    })
  },

  // 房间查询--房间流水查询--列表
  roomRunningList(data, method) {
    return ajax('post', getRequestUrl('/api/RoomRunningWater/roomRunningList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间流水查询--查看详细列表
  roomRunningDetail(data, method) {
    return ajax('post', getRequestUrl('/api/RoomRunningWater/roomRunningDetail'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间流水查询--房间监控列表
  roomMonitorList(data, method) {
    return ajax('post', getRequestUrl('/api/RoomRunningWater/roomMonitorList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间流水--修改监控
  roomMonitorUpdate(data, method) {
    return ajax('post', getRequestUrl('/api/RoomRunningWater/roomMonitorUpdate'), data, {
      method,
    })
  },

  // 房间查询--房间流水--删除监控
  roomMonitorDelete(data, method) {
    return ajax('post', getRequestUrl('/api/RoomRunningWater/roomMonitorDelete'), data, {
      method,
    })
  },

  // 房间查询--房间流水--添加监控
  roomMonitorAdd(data, method) {
    return ajax('post', getRequestUrl('/api/RoomRunningWater/roomMonitorAdd'), data, {
      method,
    })
  },

  // 房间查询--房间流水--发送金币
  runningWaterCoinAdd(data, method) {
    return ajax('post', getRequestUrl('/api/RoomRunningWater/coinAdd'), data, {
      method,
    })
  },

  // 房间查询--房间流水--查看房间小时流水
  costWholePoint(data, method) {
    return ajax('post', getRequestUrl('/api/RoomRunningWater/costWholePoint'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间管理考核--房间管理考核列表
  roomManagementCheckList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomManagementCheckList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--扶持管理--房间扶持列表
  roomSupportList(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/roomSupportList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--扶持管理--扶持修改详情
  roomSupportDetail(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/roomSupportDetail'), data, {
      method,
    })
  },

  // 房间查询--扶持管理--保存房间扶持信息
  roomSupportSave(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/roomSupportSave'), data, {
      method,
    })
  },

  // 房间查询--扶持管理--删除房间扶持
  roomSupportDelete(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/roomSupportDelete'), data, {
      method,
    })
  },

  // 房间查询--扶持管理--添加房间扶持
  roomSupportAdd(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/roomSupportAdd'), data, {
      method,
    })
  },

  // 房间查询--扶持管理--发放扶持金币
  RoomGrantSupport(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/RoomGrantSupport'), data, {
      method,
    })
  },

  // 房间查询--房间绑定--列表
  roomBindList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomBindList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间绑定--添加绑定
  roomBindAdd(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomBindAdd'), data, {
      method,
    })
  },

  // 房间查询--取消房间置顶
  cancelStickRoom(data, method) {
    return ajax('post', getRequestUrl('/api/Room/cancelStickRoom'), data, {
      method,
    })
  },

  // 房间查询--房间接待
  roomReceptionListByPage(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomReceptionListByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间接待详情
  roomReceptionStatistic(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomReceptionStatistic'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--房间接待新增或修改
  roomReceptionSet(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomReceptionSet'), data, {
      method,
    })
  },

  // 房间查询--删除房间接待信息
  roomReceptionDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomReceptionDelete'), data, {
      method,
    })
  },

  // 房间查询--奖池设置列表
  roomGameListByPage(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomGameListByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间查询--奖品类型下奖品内容
  getPropList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/getPropList'), data, {
      method,
    })
  },

  // 房间查询--奖池设置(新增或修改)
  roomGameSet(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomGameSet'), data, {
      method,
    })
  },

  // 房间查询--上下架房间转盘
  roomGameIsOn(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomGameIsOn'), data, {
      method,
    })
  },

  // 房间查询--删除房间转盘
  roomGameDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomGameDelete'), data, {
      method,
    })
  },

  // 房间查询--房间转盘--查询统计
  roomGameStatisticByPage(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomGameStatisticByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 房间管理--添加活动扶持
  activityPoorAdd(data, method) {
    return ajax('post', getRequestUrl('/api/Room/activityPoorAdd'), data, {
      method,
    })
  },

  // 房间管理-活动审核活动修改
  activityInfoSave(data, method) {
    return ajax('post', getRequestUrl('/api/Room/activityInfoSave'), data, {
      method,
    })
  },

  // 房间管理-扶持方案列表
  poorGiftList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/poorGiftList'), data, {
      method,
    })
  },

  // 房间管理-扶持方案删除
  poorGiftDel(data, method) {
    return ajax('post', getRequestUrl('/api/Room/poorGiftDel'), data, {
      method,
    })
  },

  // 房间管理-扶持方案新增
  giftPlanPostSave(data, method) {
    return ajax('post', getRequestUrl('/api/Room/giftPlanPostSave'), data, {
      method,
    })
  },

  // 房间管理-扶持方案保存
  activityPoorEdit(data, method) {
    return ajax('post', getRequestUrl('/api/Room/activityPoorEdit'), data, {
      method,
    })
  },

  // 房间管理-扶持方案保存
  rc_getSelectPlan(data, method) {
    return ajax('post', getRequestUrl('/api/Room/getSelectPlan'), data, {
      method,
    })
  },

  // 房间管理-房间认证
  rc_roomAuthenticateList(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomAuthenticateList'), data, {
      method,
    })
  },

  // 房间管理-房间认证-审核
  rc_roomAuthenticateAudit(data, method) {
    return ajax('post', getRequestUrl('/api/Room/roomAuthenticateAudit'), data, {
      method,
    })
  },

  // 房间管理-房间认证-审核列表
  rc_authenticateManagement(data, method) {
    return ajax('post', getRequestUrl('/api/Room/authenticateManagement'), data, {
      method,
    })
  },

  // 房间管理-房间认证-删除
  rc_authenticateDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Room/authenticateDelete'), data, {
      method,
    })
  },

  // 房间管理-房间认证-详情
  rc_authenticateManagementDetail(data, method) {
    return ajax('post', getRequestUrl('/api/Room/authenticateManagementDetail'), data, {
      method,
    })
  },

  // 房间管理-房间认证-保存
  rc_authenticateSet(data, method) {
    return ajax('post', getRequestUrl('/api/Room/authenticateSet'), data, {
      method,
    })
  },

  // 房间管理-房间认证-发放记录
  rc_authenticateRewardRecord(data, method) {
    return ajax('post', getRequestUrl('/api/Room/authenticateRewardRecord'), data, {
      method,
    })
  },

  // 房间管理-扶持管理-未发放记录
  rc_frozenDataList(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/frozenDataList'), data, {
      method,
    })
  },

  // 房间管理-扶持管理-扶持黑名单
  poorBlackList(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/poorBlackList'), data, {
      method,
    })
  },

  // 房间管理-扶持管理-删除扶持申请
  poorRoomActivityDel(data, method) {
    return ajax('post', getRequestUrl('/api/Room/poorRoomActivityDel'), data, {
      method,
    })
  },

  // 房间管理-扶持管理-批量删除
  poorBlackDelete(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/poorBlackDelete'), data, {
      method,
    })
  },

  // 房间管理-扶持管理-新增
  addPoorBlack(data, method) {
    return ajax('post', getRequestUrl('/api/RoomSupport/addPoorBlack'), data, {
      method,
    })
  },

  // 房间管理-重置信息
  resetRoomInfo(data, method) {
    return ajax('post', getRequestUrl('/room/resetInfo'), data, {
      method,
    })
  },

  // 房间外框列表
  roomHeadwearList(data, method) {
    return ajax('post', getRequestUrl('/room/headwear/list'), data, {
      method,
    })
  },

  // 新增/编辑 房间外框
  roomHeadwearSave(data, method) {
    return ajax('post', getRequestUrl('/room/headwear/save'), data, {
      method,
    })
  },

  // 申请记录 或者 发放记录
  roomSupportSubmitList(data, method) {
    return ajax('post', getRequestUrl('/room/roomSupport/submit/list'), data, {
      method,
    })
  },

  // 领取详情
  roomSupportSubmitDetail(data, method) {
    return ajax('post', getRequestUrl('/room/roomSupport/submit/detail'), data, {
      method,
    })
  },

  // 领取失败记录
  roomSupportFailList(data, method) {
    return ajax('post', getRequestUrl('/room/roomSupport/get_fail/list'), data, {
      method,
    })
  },

  // 房间海报
  getRoomPosterList(data, method) {
    return ajax('post', getRequestUrl('/room/poster/list'), data, {
      method,
    })
  },
  delRoomPosterList(data, method) {
    return ajax('post', getRequestUrl('/room/poster/delete'), data, {
      method,
    })
  },
  addRoomPoster(data, method) {
    return ajax('post', getRequestUrl('/room/poster/save'), data, {
      method,
    })
  },


}



// WEBPACK FOOTER //
// ./src/js/https/room.js